import SemanticClasses from '../../typings/semantic/semanticClasses';
import WrappedText from '../wrappedText';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Colors, Icons } from 'copyright-clearance-center-common-ui';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			alignItems: 'center',
			alignSelf: 'stretch',
			userSelect: 'none',
			cursor: 'pointer',
			display: 'flex',
			flexDirection: 'row',
			borderRadius: '0.25rem',
			height: '2rem',
			padding: '0.38rem 0.5rem',
			justifyContent: 'space-between',
			columnGap: '0.25rem'
		},
		label: {
			fontWeight: '500',
			flexGrow: 1
		},
		count: {
			fontWeight: '400'
		},
		font: {
			fontSize: '0.875rem',
			color: Colors.neutral900,
			lineHeight: '1.25rem'
		},
		fontSelected: {
			color: '#fff !important'
		},
		navigatePanel: {
			display: 'flex',
			gap: '0.25rem',
			alignItems: 'center'
		}
	})
);

export interface ITopicProps {
	label: string;
	count: number;
	selected: boolean;
	className?: string;
	onTopicClick: () => void;
	onNavigateClick?: (previous: boolean) => void;
}

const Topic: React.FunctionComponent<ITopicProps> = ({ selected, onTopicClick, onNavigateClick, ...props }) => {
	const classes = useStyles();
	const getNavigateButton = (previous: boolean) => {
		return (
			<span
				className={clsx('rup-icon rup-icon--sm', classes.font, {
					[classes.fontSelected]: selected
				})}
				onClick={e => {
					e.stopPropagation();
					onNavigateClick(previous);
				}}
				dangerouslySetInnerHTML={{ __html: previous ? Icons.ChevronLeftIcon : Icons.ChevronRightIcon }}
			/>
		);
	};

	return (
		<div
			className={clsx(classes.root, SemanticClasses.semanticTopic, {
				[SemanticClasses.semanticTopicSelected]: selected
			})}
			onClick={onTopicClick}
		>
			<WrappedText
				className={clsx(classes.label, classes.font, {
					[classes.fontSelected]: selected
				})}
				text={props.label}
			/>
			<div
				className={clsx(classes.count, classes.font, {
					[classes.fontSelected]: selected
				})}
			>
				{props.count}
			</div>
			{onNavigateClick && (
				<div className={classes.navigatePanel}>
					{getNavigateButton(true)}
					{getNavigateButton(false)}
				</div>
			)}
		</div>
	);
};

export default Topic;
